import { wrapSyncFunc } from '../../util';
var w3cEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
export var email = wrapSyncFunc(function (rule, value) {
  if (typeof value !== 'string' || value === '') {
    return;
  }

  return w3cEmail.test(value);
});